module.exports = __webpack_public_path__ + "house-twilight.5b6ffe0f48613c50ae02.svg";


//////////////////
// WEBPACK FOOTER
// /vercel/path0/src/assets/img/house-twilight.svg
// module id = ../../../../../src/assets/img/house-twilight.svg
// module chunks = main